// Dropdown Menu functionality
(function() {
    'use strict';

    function createDropdownMenus() {
        const navItems = document.querySelectorAll('.gh-head-menu li');
        const menuStructure = buildMenuStructure(navItems);
        applyDropdowns(menuStructure);
    }

    function buildMenuStructure(navItems) {
        const mainMenuItems = [];
        const subMenus = {};

        navItems.forEach((item, index) => {
            const link = item.querySelector('a');
            if (!link) return; // Skip items without a link

            const linkText = link.textContent.trim();
            if (linkText.startsWith('-')) {
                const parentIndex = mainMenuItems.length - 1;
                if (!subMenus[parentIndex]) {
                    subMenus[parentIndex] = [];
                }
                subMenus[parentIndex].push(item);
            } else {
                mainMenuItems.push(item);
            }
        });

        return { mainMenuItems, subMenus };
    }

    function applyDropdowns({ mainMenuItems, subMenus }) {
        mainMenuItems.forEach((item, index) => {
            const subMenuItems = subMenus[index];
            if (subMenuItems) {
                // Check if the dropdown and caret icon already exist
                if (!item.querySelector('.dropdown') && !item.querySelector('.caret-down')) {
                    const dropdown = createDropdownElement(subMenuItems);
                    item.classList.add('has-dropdown');
                    
                    // Add caret-down icon
                    const caretIcon = document.createRange().createContextualFragment(`
                        <svg xmlns="http://www.w3.org/2000/svg" width="192" height="192" fill="currentColor" viewBox="0 0 256 256" class="icon caret-down">
                            <rect width="256" height="256" fill="none"></rect><polyline points="208 96 128 176 48 96" fill="none" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="24"></polyline>
                        </svg>
                    `);
                    item.querySelector('a').appendChild(caretIcon);
                    
                    item.appendChild(dropdown);
                    
                    // Add hover event listeners
                    item.addEventListener('mouseenter', () => {
                        item.classList.add('show-dropdown');
                        item.querySelector('.caret-down').classList.add('rotate');
                    });
                    
                    item.addEventListener('mouseleave', () => {
                        item.classList.remove('show-dropdown');
                        item.querySelector('.caret-down').classList.remove('rotate');
                    });
                }
            }
        });
    }

    function createDropdownElement(subMenuItems) {
        const dropdown = document.createElement('ul');
        dropdown.className = 'dropdown';
        
        subMenuItems.forEach(child => {
            const link = child.querySelector('a');
            if (link) {
                // Remove the leading dash and trim whitespace
                const cleanedText = link.textContent.replace(/^\s*-\s*/, '').trim();
                
                // Update the HTML content of the link
                link.innerHTML = cleanedText;
            }
            dropdown.appendChild(child);
        });

        return dropdown;
    }

    // Utility function for debouncing
    function debounce(func, delay) {
        let timeoutId;
        return (...args) => {
            clearTimeout(timeoutId);
            timeoutId = setTimeout(() => func.apply(null, args), delay);
        };
    }

    // Initialize dropdown menus
    const debouncedCreateDropdownMenus = debounce(createDropdownMenus, 100);

    // Run immediately
    createDropdownMenus();

    // Run on DOM content loaded as fallback
    document.addEventListener('DOMContentLoaded', createDropdownMenus);

    // Observe DOM changes
    const observer = new MutationObserver(debouncedCreateDropdownMenus);
    observer.observe(document.body, { childList: true, subtree: true });
})(); 